import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  NoticesAnalysisByGroupQuery,
  NoticesAnalysisByGroupRequestSchema,
  NoticesSearchRequest,
} from "../../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../../utils";

export type NoticesAnalysisByGroupQueryKey = [
  "noticesAnalysisByGroup",
  NoticesSearchRequest,
  NoticesAnalysisByGroupRequestSchema,
];

const noticesAnalysisByGroupQuery = graphql(`
  query noticesAnalysisByGroup(
    $request: NoticesSearchRequest!
    $byGroupOptions: NoticesAnalysisByGroupRequestSchema!
  ) {
    notices(NoticesSearchRequest: $request) {
      totalResults
      analysis {
        overall {
          noticeValues
        }
        byGroup(NoticesAnalysisByGroupRequest: $byGroupOptions) {
          totalResults
          maxNoticeCount
          maxNoticeValues
          results {
            guid
            name
            noticeCount
            noticeValues
            isSavedCount
          }
        }
      }
    }
  }
`);

export function useNoticesAnalysisByGroup(
  searchNoticesRequest: NoticesSearchRequest,
  byGroupOptions: NoticesAnalysisByGroupRequestSchema,
  options?: UseQueryOptions<
    NoticesAnalysisByGroupQuery,
    unknown,
    NoticesAnalysisByGroupQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery<
    NoticesAnalysisByGroupQuery,
    {
      request: NoticesSearchRequest;
      byGroupOptions: NoticesAnalysisByGroupRequestSchema;
    }
  >(
    ["noticesAnalysisByGroup", searchNoticesRequest, byGroupOptions],
    noticesAnalysisByGroupQuery,
    [{ request: searchNoticesRequest, byGroupOptions }],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );

  return {
    data: data?.notices,
    ...rest,
  };
}
